import React, { PropsWithChildren } from 'react';
import { ModalDialog } from '@dtsl/react';
import enhanceMessage from './enhanceMessage';
import { TwilioError } from 'twilio-video';

interface ErrorDialogProps {
  dismissError: Function;
  error: TwilioError | null;
}

function ErrorDialog({ dismissError, error }: PropsWithChildren<ErrorDialogProps>) {
  const { message, code } = error || {};
  const enhancedMessage = enhanceMessage(message, code);

  return (
    <ModalDialog
      key={error ? code : 'no-error'}
      isVisible={error !== null}
      closeModal={() => {
        dismissError();
      }}
      size="sm"
    >
      <ModalDialog.Header title="Uh-oh" />
      <ModalDialog.Body>
        {/* this style is a copy paste from design system */}
        <div className="sib-typo_text-body" style={{ padding: '24px 32px' }}>
          {enhancedMessage}
          {Boolean(code) && (
            <pre>
              <code>Error Code: {code}</code>
            </pre>
          )}
        </div>
      </ModalDialog.Body>
      <ModalDialog.Footer
        primaryAction={{
          id: 'video-calls-error-dialog-ok',
          variant: 'primary',
          label: 'OK',
          onClick: () => dismissError(),
        }}
      />
    </ModalDialog>
  );
}

export default ErrorDialog;
